import { render } from "./SitesLoader.vue?vue&type=template&id=5ae9815b&ts=true"
import script from "./SitesLoader.vue?vue&type=script&lang=ts"
export * from "./SitesLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__